import { type Rotina, rotinaSchema } from '@acme/core'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useRotinasOutletContext } from 'pages/Rotinas.context'
import { useParams } from 'react-router-dom'
import { rotinas } from 'service/api'
import { toast } from 'sonner'
import { RotinaForm } from '../atoms/RotinaForm'

export default function EditarRotina() {
    const { id } = useParams()
    const { data } = useRotinasOutletContext()
    const rotina = data?.find(it => it.id === Number(id))
    const { mutateAsync, isLoading } = rotinas.mutations.useUpdate({
        invalidateQuery: true,
    })

    if (!rotina) return null

    const handleSubmit = (input: Rotina) =>
        mutateAsync(
            { ...input, id: rotina.id },
            {
                onSuccess: () => {
                    toast.success('Rotina atualizada com sucesso')
                },
                onError: err => {
                    toast.error(err.message)
                },
            },
        )

    return (
        <Dialog.Root
            width="3xl"
            shouldTransformarValores={false}
            loading={isLoading}
            onSubmit={handleSubmit}
            schema={rotinaSchema}
            defaultValues={rotina}
            open={hasPermission(['update', 'Rotinas'])}
        >
            <Dialog.Title action="Editar rotina">{rotina.nome}</Dialog.Title>
            <Dialog.Content>
                <RotinaForm />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
